import { DeviceProfileSetting } from './device-profile-setting.model';
import { DeviceProfileSettingDto } from '../dto/device-profile-setting.dto';
import { DeviceProfileDto } from '../dto/device-profile.dto';

export class DeviceProfile {
  public static fromDTO(deviceProfileDto: DeviceProfileDto): DeviceProfile {
    const deviceProfile: any = deviceProfileDto.deviceProfile;
    return new DeviceProfile(
      deviceProfile.name,
      deviceProfile.companyId,
      deviceProfile.defaultProfile,
      deviceProfile.moduleName,
      deviceProfileDto.settings.map((setting: DeviceProfileSettingDto) => {
        return new DeviceProfileSetting(
          setting.settingKey,
          setting.settingValue,
          setting.oid,
          setting.fid
        );
      }),
      deviceProfile.oid
    );
  }

  public static copy(deviceProfile: DeviceProfile): DeviceProfile {
    deviceProfile.id = 0;
    deviceProfile.defaultProfile = false;
    deviceProfile.name = 'Copy of ' + deviceProfile.name;
    deviceProfile.settings.forEach((setting: DeviceProfileSetting) => {
      setting.id = 0;
      setting.liteserverId = 0;
    });
    return deviceProfile;
  }

  constructor(
    public name: string,
    public companyId: number,
    public defaultProfile: boolean,
    public moduleName: string = 'restaurant',
    public settings: Array<DeviceProfileSetting> = [],
    public id?: number
  ) {}

  public toDTO(deviceProfile: DeviceProfile): DeviceProfileDto {
    const deviceProfileDto: any = Object.assign({}, deviceProfile);
    const settings: Array<any> = deviceProfile.settings.map(
      (setting: DeviceProfileSetting) => {
        return {
          settingKey: setting.settingKey,
          settingValue: JSON.stringify(setting.settingValue),
          oid: setting.id,
          fid: setting.liteserverId
        };
      }
    );
    deviceProfileDto.settings = settings;
    deviceProfileDto.oid = deviceProfile.id;
    return deviceProfileDto;
  }
}
